module.exports = __webpack_public_path__ + "img/facebook.9858fd95.svg";